import Vue from 'vue';
import Vuex from 'vuex';
import createLogger from 'vuex/dist/logger';

import auth from './auth';
import password from './password';
import notifications from './notifications';
import menu from './menu';
import settings from './settings';
import userNotifications from './userNotifications';
import createPersistedState from "vuex-persistedstate";
import { APP_ENV } from '@/config/runtime';

const debug = process.env.NODE_ENV !== 'production';

Vue.use(Vuex);

const persistedState = createPersistedState({
  key: `nase_hnutie_client_${APP_ENV}`,
  reducer: (state) => ({
    auth: {
      token: state.auth.token,
      username: state.auth.username,
      verified: state.auth.verified,
      verified_sms_email: state.auth.verified_sms_email,
      verified_email: state.auth.verified_email,
      verified_bank: state.auth.verified_bank,
      staff: state.auth.staff,
      moderator: state.auth.moderator,
      member_status: state.auth.member_status,
      firstName: state.auth.firstName,
      lastName: state.auth.lastName,
      gender: state.auth.gender,
      user_id: state.auth.user_id,
    },
    menu: state.menu,
    settings: state.settings,
    userNotifications: state.userNotifications,
  }),
});

export default new Vuex.Store({
  modules: {
    auth,
    password,
    notifications,
    userNotifications,
    menu,
    settings
  },
  strict: debug,
  plugins: debug ? [createLogger(), persistedState] : [persistedState],
});
